import type { SmartCreationChatStoreApi } from '@atlassian/smart-creation/smart-creation-chat-store-api';

import { useChatStore, useChatStoreActions } from '../main';
import { processConversationMessages } from '../processConversationMessages';

export function useSmartCreationChatStoreApi(): SmartCreationChatStoreApi {
	const [{ currentConversationId, conversations }] = useChatStore();
	const {
		createConversationOptimistically,
		setSelectedConversation,
		sendMessage,
		abortRequests,
		seedConversation,
	} = useChatStoreActions();

	const activeConversation = conversations[currentConversationId];

	return {
		createConversationOptimistically,
		setSelectedConversation,
		abortRequests,
		activeConversationId: currentConversationId,
		activeConversation,
		sendMessage,
		seedConversation,
		processConversationMessages,
	};
}
